import { useTranslation } from "react-i18next";
import { Title } from "sunday-component";
import { FlexVerticalContainer } from "../style/AffiliatePage.style";
import {
  LinkTextBox,
  StyledCopyIcon,
  LinkText,
} from "./ShareLinkTextBox.styled";

type ShareLinkTextBoxProps = {
  onWriteClipboard: () => void;
  shareLinkUrl: string;
};
export const ShareLinkTextBox = ({
  onWriteClipboard,
  shareLinkUrl,
}: ShareLinkTextBoxProps) => {
  const { t } = useTranslation(["affiliate", "common"]);

  return (
    <FlexVerticalContainer rowGap="8px" style={{ textAlign: "start" }}>
      <Title level={7}>{t("report.yourLink")}</Title>
      <LinkTextBox onClick={onWriteClipboard}>
        <LinkText>{shareLinkUrl}</LinkText>
        <StyledCopyIcon
          src="/static/pages/userProfile/copy.svg"
          alt="Copy Logo"
        />
      </LinkTextBox>
    </FlexVerticalContainer>
  );
};
